import { Post, Get } from '@/libs/http'
import store from '@/store/index.js'

// 登录
export function apiAuthLogin(data) {
  return Post('/web/api/auth/login', data)
}

// 获取公用信息
export function apiCommonInfo() {
  return Get('/web/api/common/info')
}

// 我的课程列表-按天
export function myClassGroupList(params) {
  return Get('/web/api/group/myClassGroupList', params)
}

// 我的课程表-时间段
export function myClassGroupListByMonth(params) {
  return Get('/web/api/group/myClassGroupListByMonth', params)
}

// 我的Demo课记录-课程
export function myDemoList(params) {
  return Get('/web/api/group/myDemoList', params)
}

// 我的Demo课记录-章节
export function myDemoGroupList(params) {
  return Get('/web/api/group/myDemoGroupList', params)
}

// 我的考核期-课程
export function myTrialList(params) {
  return Get('/web/api/group/myTeacherList', params)
}

// 我的考核期-章节
export function myTrialGroupList(params) {
  return Get('/web/api/group/myTeacherGroupList', params)
}

// 获取课节
export function myGroupList(classGroupId) {
  return Get('/web/api/group/myGroupList', { classGroupId })
}

// step 列表（按类型）
export function stepListByType(data) {
  return Post('/web/api/step/listByType', data)
}

// step 列表（按小组）
export function stepListByGroupId(data) {
  if (!data.telnum) {
    data.telnum = store.state.Telnum
  }
  return Post('/web/api/step/listByGroupId', data)
}

// 保存日志（按小组）
export function saveLog(data) {
  if (!data.telnum) {
    data.telnum = store.state.Telnum
  }
  return Post('/web/api/log/save', data)
}
// 用户信息统计
export function statSend(data) {
  return Post('/web/api/stat/send', data)
}

// 获取视频
export function getVideo(videoId) {
  return Get(`/web/video/get/${videoId}`)
}

// 获取视频播放凭证
export function getVideoAuth(videoId) {
  return Get(`/web/video/playAuthGet/${videoId}`)
}

// 所有资源列表查询接口
export function categorizeList(params) {
  return Get('/web/api/categorize/list', params)
}

// 所有分类列表查询接口
export function categorizeAllCategory(params) {
  return Get('/web/api/categorize/allCategory', params)
}

// 所有分类列表查询接口
export function myGroupMaterialList(params) {
  return Get('/web/api/group/myGroupMaterialList', params)
}

// 修改密码
export function apiAuthUpdatePwd(params) {
  return Post(`/web/api/auth/updatePwd`, params)
}

// 获取OSS签名URL
export function getAliyunWebOffice(fileName) {
  return Get(`/web/aliyun/webOffice`, { fileName })
}

export function getAliyunWebOfficeToken(fileName) {
  return Get(`/web/aliyun/webofficeToken`, { fileName })
}
// 生成WebofficeToken
export function generateWebofficeToken(fileName) {
  return Get(`/web/aliyun/generateWebofficeToken`, { fileName })
}
// 刷新WebofficeToken
export function refreshWebofficeToken(params) {
  return Get(`/web/aliyun/refreshWebofficeToken`, params)
}

// 获取课节锁定时间
export function getGroupLockTimeList(classGroupId) {
  return Get(`/web/api/group/myGroupLockTimeList`, { classGroupId })
}

// 网盘资源根据id查询
export function getCategorizeById(id) {
  return Get('/web/api/categorize/first', { id })
}

// 获取线上课程链接
export function getOnlineLessonLink({ courseNumber, cesLessonNumber }) {
  return Get('/web/lesson/getH5Link', { courseNumber, cesLessonNumber })
}
